import type {
	CommitmentExceptionReason,
	CommitmentExceptionStatus,
} from '@/types'

export const COMMITMENT_EXCEPTION_REASON_LABELS: Record<
	CommitmentExceptionReason,
	string
> = {
	FERIAS: 'Férias',
	ATESTADO: 'Atestado',
	AFASTAMENTO: 'Afastamento',
	TRANSFERIDO: 'Transferido',
	FOLGA_DE_CAMPO: 'Folga de campo',
	EM_MOBILIZACAO: 'Em mobilização',
	LICENCA_MATERNIDADE: 'Licença maternidade',
	OUTRO: 'Outro',
}

export const COMMITMENT_EXCEPTION_STATUS_LABELS: Record<
	CommitmentExceptionStatus,
	string
> = {
	PENDENTE: 'Pendente',
	APROVADO: 'Aprovado',
	REJEITADO: 'Rejeitado',
}

export const COMMITMENT_EXCEPTION_STATUS_BADGE_CLASS: Record<
	CommitmentExceptionStatus,
	string
> = {
	PENDENTE: 'bg-kaefer-honey-yellow/20 text-kaefer-dark-grey',
	APROVADO: 'bg-kaefer-grass-green/15 text-kaefer-forest-green',
	REJEITADO: 'bg-kaefer-red/15 text-kaefer-red',
}

export const COMMITMENT_EXCEPTION_STATUS_BAR_CLASS: Record<
	CommitmentExceptionStatus,
	string
> = {
	PENDENTE: 'bg-kaefer-honey-yellow',
	APROVADO: 'bg-kaefer-grass-green',
	REJEITADO: 'bg-kaefer-red/60',
}
